import React, {
  useRef, useState, useCallback, useEffect,
} from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import './SelectInputStyles.scss';
import { useDispatch } from 'react-redux';
import { Icons } from '../../base/BootstrapComponents/BootstrapComponents';
import Dropdown from '../../base/Dropdown/Dropdown';
import TextInput from '../TextInput/TextInput';
import { errorNotification } from '../../../modules/Notifications/notificationDecorator';
import { getResponseError } from '../../../utils/utils';
import { LOADING_DELAY } from '../../../configs';
import CheckBoxInputWithLabel from '../CheckBoxInput/CheckBoxInputWithLabel';

export default function SelectInputWithHelper(props) {
  const {
    inputProps = null,
    className = '',
    fieldState = {
      error: '',
      touched: false,
    },
    // Это не криптография! Если ваш анализатор этого не понимает не используйте этот анализатор
    // nosemgrep
    controlId = `text-input-${Math.random() * 10000}`,
    renderOption = null,
    addPlaceholder = false,
    useDefaultNull = false,
    placeholder = '',
    multiple = false,
    customToggleContent = null,
    disabled = false,
    inputClassName = '',
    portalClassName = '',
    variant = '',
    filterName = 'search',
    customRenderOptions = null,
    loadAction,
    additionalFilter = {},
    optionFormatter = null,
    defaultOptions = [],
    withSearch = false,
  } = props;
  const {
    error,
    isTouched: touched,
  } = fieldState;
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const anchorElement = useRef(null);
  const [options, setOptions] = useState([]);
  const [search, setSearch] = useState('');
  const isError = Boolean(error);
  const [timer, setTimer] = useState(null);
  const [toggleFunction, setToggleFunction] = useState(() => () => {});
  const defaultRenderOption = item => (typeof item === 'string' ? item : !item.name && item.nameId ? formatMessage({ id: item.nameId }) : item.name || '');
  let renderOptionFunction = customRenderOptions || defaultRenderOption;
  if (renderOption && typeof renderOption === 'function') {
    renderOptionFunction = renderOption;
  }

  const value = inputProps && (typeof inputProps.value !== 'undefined') ? inputProps.value : null;
  const name = inputProps && (typeof inputProps.name !== 'undefined') ? inputProps.name : '';

  useEffect(() => {
    if (typeof loadAction === 'function') {
      loadOptions();
    }
  }, []);

  const onChange = item => {
    if (inputProps && inputProps.onChange) {
      const changeValue = item.value;
      inputProps.onChange({ target: { value: changeValue, name: inputProps.name } });
      setSearch('');
    }
  };

  const loadOptions = (value = '') => {
    const defaultOptionFormatter = item => ({ value: item.id, name: item.number });
    dispatch(loadAction({ filter: { [filterName]: value, ...additionalFilter } }))
      .then(data => {
        if (!data?.data) { return; }
        setOptions((data?.data || []).map(optionFormatter || defaultOptionFormatter));
      })
      .catch(response => errorNotification('Загрузка данных', getResponseError(response)));
  };

  const onChangeSearch = event => {
    const { value } = event.target;
    inputProps.onChange({ target: { value, name: inputProps.name } });
    if (withSearch) {
      setSearch(value);
      if (!loadAction) return;
      if (timer) {
        clearTimeout(timer);
      }
      setTimer(setTimeout(() => { loadOptions(value); }, LOADING_DELAY));
    }
  };

  const inputOption = [...defaultOptions, ...options].find(i => i.value === value) || value;
  const inputValue = inputOption ? defaultRenderOption(inputOption) : '';

  const isSelectedPlaceholder = value => {
    if ((Array.isArray(value) && !value.length) || value === null) {
      return true;
    }
    if (typeof value === 'number' || typeof value === 'string') {
      return !String(value);
    }
    return false;
  };

  const onReset = event => {
    const v = useDefaultNull ? null : '';
    inputProps.onChange({ target: { value: v, name: inputProps.name } });
    setSearch('');
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <div className={classNames('form-control-wrapper', className)}>
      <Dropdown
        usePortal
        disabled={disabled}
        setToggleFunction={a => setToggleFunction(() => a)}
      >
        <Dropdown.Toggle className="select-toggle">
          {!customToggleContent || typeof customToggleContent !== 'function'
            ? (
              <TextInput
                {...props}
                inputAfter={(
                  <div id={controlId} className="select-arrow-wrapper">
                    {search || inputValue ? <Icons customIcon onClick={onReset} width={18} height={18} icon="close" /> : null}
                    <Icons customIcon className="select-arrow" width={12} height={8} icon="arrow-down" />
                  </div>
                )}
                className={classNames('custom-select', { 'is-invalid': isError && touched }, inputClassName)}
                fieldState={fieldState}
                containerRef={anchorElement}
                inputProps={{
                  name,
                  onChange: onChangeSearch,
                  value: search || inputValue,
                }}
                variant={variant}
              />
            )
            : customToggleContent(props, value, options, anchorElement)}
        </Dropdown.Toggle>
        <Dropdown.Menu
          useResizeContent={false}
          disableClickToggle={multiple}
          rightPadding={32}
          className="select-options-wrapper with-filter"
          anchorElement={anchorElement}
          classNamePortal={classNames('portal-select-options', portalClassName)}
        >
          <div className="select-options-list">
            {addPlaceholder
              ? (
                <div
                  className={classNames('select-option', { selected: isSelectedPlaceholder(value) })}
                  onClick={() => { onChange({ value: useDefaultNull ? null : '' }); }}
                >
                  {renderOptionFunction({ name: placeholder || '' })}
                </div>
              )
              : null}
            {options.map((item, key) => {
              const isSelected = item.value === value;
              return (
                <div
                  key={key}
                  className={classNames('select-option', { selected: isSelected })}
                  onClick={() => { onChange(item); }}
                >
                  {renderOptionFunction(item, key, isSelected)}
                </div>
              );
            })}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
